"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MfaTotpChallengeRequestSchema () {
        return MfaTotpChallengeRequestSchema;
    },
    get MfaTotpChallengeResponseSchema () {
        return MfaTotpChallengeResponseSchema;
    }
});
const _zod = require("zod");
const _tokenpair = require("./token-pair");
const MfaTotpChallengeRequestSchema = _zod.z.object({
    mfaToken: _zod.z.string().min(20),
    code: _zod.z.string().regex(/^\d{6}$/, 'code must be 6 digits')
});
const MfaTotpChallengeResponseSchema = _tokenpair.TokenPairSchema;
